import {
  DebouncedTextInput,
  type DebouncedTextInputProps,
} from "./debounced-text-input";

export const DebouncedSearchInput = (props: DebouncedTextInputProps) => {
  return (
    <DebouncedTextInput
      type="search"
      placeholder="Search..."
      rightIcon={<i className="fa-regular fa-magnifying-glass"></i>}
      {...props}
    />
  );
};
